import React, {useState, useEffect} from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import PropertyCard from "../PropertyCard/PropertyCard";
import Slider from "react-slick";
import $ from "jquery";

import {hasMyaccount, slider_count } from "../../common/constant"
import { UserObjectStoreProvider, getUserobjectData, isAuthenticated } from "@starberry/myaccount-website-utils";

import "./Features.scss";

import {FeaturedProperties, FeaturedPropertiesOffice} from "../../common/queries/common_use_query"

const FeaturesOffice = ({Module, office_crm_id, tab_list, h1_title, defaultTitle}) => {
    const[department, setDepartment] = useState("residential")
    //const[search_type, setSearchType] = useState("sales")
    const[featTitle, setFeatTitle] = useState("Property for Sale")

    //const{loading, error, data} = office_crm_id ?  FeaturedPropertiesOffice(department, search_type, office_crm_id) : FeaturedProperties(department, search_type);

    //console.log("office_crm_id", office_crm_id)

    const{loading, error, data} = FeaturedPropertiesOffice(department, office_crm_id);
    const [modalShow, setModalShow] = React.useState(false);
    const [book_a_viewing_link, setViewingLink] = React.useState("");

    const [userObjects, setUserObjects] = useState({});
    const authuser = isAuthenticated()

    useEffect(() => {
    if (authuser && hasMyaccount) {
        const getUserObjects = async () => {
            try {
                const userObjects = await getUserobjectData()
                setUserObjects(userObjects.data.data)
            } catch (e) {
                console.log("e:", e)
            }
        }
        getUserObjects()
    }
    }, [])

    //console.log("properties ==>", data?.sale_properties,  data?.let_properties)
    let sales_properties = data?.sale_properties
    let letting_properties = office_crm_id?.length > 0 ? data?.let_properties : data?.recent_let_properties
    let newhomes_properties = data?.newhomes_properties
    let student_properties = data?.student_properties
    
    useEffect(()=>{
        if(sales_properties?.length > 0 ){
            setFeatTitle("Property for Sale")
        } else if(letting_properties?.length > 0 ){
            setFeatTitle("Property to Rent")
        }
        
    },[sales_properties, letting_properties])

    const handleChange = (event) =>{
        //console.log("event ==>", event.target.firstChild.data)
        var get_tab_key = event.target.attributes.getNamedItem("data-rr-ui-event-key").value;
        var split_tab_value = get_tab_key.split("_");
        var feat_tilte = event.target.firstChild.data;
        //setDepartment(split_tab_value[0])
        //setSearchType(split_tab_value[1])
        setFeatTitle(feat_tilte)

        //console.log("tab_key", event.target.attributes.getNamedItem("data-rr-ui-event-key").value)
    }
    
    var settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: slider_count || 4,
        slidesToScroll: 1,
        mobileFirst: true,
        afterChange: (event) => {
            var activeDotEl = $('.features .slick-slider').find('.slick-dots').find('li.slick-active');
            if(activeDotEl.get(0)){
                activeDotEl.get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
            
        },
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    dots: false,
                    arrows: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    dots:true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },

        ],
    };

    if(loading){
        return ''
    }

    //console.log("student_properties", student_properties);


    return (

        <React.Fragment>
            <UserObjectStoreProvider>
            {(sales_properties?.length > 0 || letting_properties?.length > 0 || student_properties?.length > 0) &&
            <section className={`features  ${Module?.background_clr} ${Module?.feat_padd}`}>
                <Container>
                    <Row>
                        <Col>
                        <>
                            {Module?.title ? 
                                <h2>{Module?.title}</h2>
                            : defaultTitle ?
                                <h2>{defaultTitle}</h2>
                            :
                                <h2>{featTitle} in {h1_title}</h2>
                            }
                            
                            <div className="tab-wrapper">                                
                                <Tabs
                                    defaultActiveKey={tab_list[0].tab_name}
                                    id="uncontrolled-tab-example"
                                    onClick={handleChange}
                                    >
                                    {tab_list.map((item, index) => {
                                        if(item.add_tab === "residential_sales" || item.add_tab === "residential_sold"){
                                            return(
                                                sales_properties?.length > 0 && 
                                                <Tab eventKey={item.tab_name} title={item.tab_name} >
                                                    <Slider {...settings}>
                                                        {sales_properties?.map((item, index) => (
                                                            <PropertyCard key={index} FeaturesList={item} setModalShow={setModalShow} setViewingLink={setViewingLink} userObjects={userObjects}/>
                                                        ))}
                                                    </Slider>
                                                </Tab>
                                            )
                                        }

                                        if(item.add_tab === "residential_lettings" || item.add_tab === "residential_let"){
                                            return(
                                                letting_properties?.length > 0 && 
                                                <Tab eventKey={item.tab_name} title={item.tab_name} >
                                                    <Slider {...settings}>
                                                        {letting_properties?.map((item, index) => (
                                                            <PropertyCard key={index} FeaturesList={item} setModalShow={setModalShow} setViewingLink={setViewingLink} userObjects={userObjects}/>
                                                        ))}
                                                    </Slider>
                                                </Tab>                                                
                                            )
                                        }

                                        if(item.add_tab === "new_homes"){
                                            return(
                                                newhomes_properties?.length > 0 && 
                                                <Tab eventKey={item.tab_name} title={item.tab_name} >
                                                    <Slider {...settings}>
                                                        {newhomes_properties?.map((item, index) => (
                                                            <PropertyCard key={index} FeaturesList={item} setModalShow={setModalShow} setViewingLink={setViewingLink} userObjects={userObjects}/>
                                                        ))}
                                                    </Slider>
                                                </Tab>
                                            )
                                        }

                                        if(item.add_tab === "students"){
                                            return(
                                                student_properties?.length > 0 && 
                                                <Tab eventKey={item.tab_name} title={item.tab_name} >
                                                    <Slider {...settings}>
                                                        {student_properties?.map((item, index) => (
                                                            <PropertyCard key={index} FeaturesList={item} setModalShow={setModalShow} setViewingLink={setViewingLink} userObjects={userObjects}/>
                                                        ))}
                                                    </Slider>
                                                </Tab>
                                            )
                                        }
                                        
                                    })}
                                    {/* {sales_properties?.length > 0 && 
                                        <Tab eventKey={"Property for Sale"} title={"Property for Sale"} >
                                            <Slider {...settings}>
                                                {sales_properties?.map((item, index) => (
                                                    <PropertyCard key={index} FeaturesList={item} setModalShow={setModalShow} setViewingLink={setViewingLink} userObjects={userObjects}/>
                                                ))}
                                            </Slider>
                                        </Tab>
                                    }

                                    {letting_properties?.length > 0 && 
                                        <Tab eventKey={"Property to Rent"} title={"Property to Rent"} >
                                            <Slider {...settings}>
                                                {letting_properties?.map((item, index) => (
                                                    <PropertyCard key={index} FeaturesList={item} setModalShow={setModalShow} setViewingLink={setViewingLink} userObjects={userObjects}/>
                                                ))}
                                            </Slider>
                                        </Tab>
                                    } */}
                                </Tabs>                             
                            </div>
                        </>
                            
                        </Col>
                    </Row>
                </Container>

                <Modal
                    show={modalShow}
                    onHide={() => {setModalShow(false); setViewingLink("")}}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter" className="book_a_viewing_ttl">
                            Book a Viewing
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="team_content col-md-12 col-lg-18 p-0">
                            <iframe src={book_a_viewing_link} height="600" width={"100%"} className="book_a_viewing" />
                        </div>
                    </Modal.Body>
                </Modal>
            </section>
            }
        </UserObjectStoreProvider>
        </React.Fragment>
    );
};
export default FeaturesOffice;
